<template>
  <nav class="admin-nav">
    <!-- Brand -->
    <div class="nav-brand">🔐 Admin — Fidélité Marché</div>

    <!-- Desktop links -->
    <div class="nav-links">
      <router-link to="/admin/dashboard">📊 Stats</router-link>
      <router-link to="/admin/commercants">🏪 Commerçants</router-link>
      <router-link to="/admin/clients">👥 Clients</router-link>
      <router-link to="/admin/cartes">🎴 Cartes</router-link>
      <router-link to="/admin/journees">📅 Journées</router-link>
      <router-link to="/admin/sql">💾 SQL</router-link>
    </div>

    <!-- Desktop logout -->
    <button class="btn-logout desktop-only" @click="logout">Déconnexion</button>

    <!-- Mobile hamburger -->
    <button class="hamburger mobile-only" @click="menuOuvert = !menuOuvert" :class="{ open: menuOuvert }">
      <span></span><span></span><span></span>
    </button>

    <!-- Mobile menu -->
    <div class="mobile-menu" :class="{ open: menuOuvert }">
      <router-link to="/admin/dashboard">📊 Stats</router-link>
      <router-link to="/admin/commercants">🏪 Commerçants</router-link>
      <router-link to="/admin/clients">👥 Clients</router-link>
      <router-link to="/admin/cartes">🎴 Cartes fidélité</router-link>
      <router-link to="/admin/journees">📅 Journées</router-link>
      <router-link to="/admin/sql">💾 SQL</router-link>
      <button class="btn-logout-mobile" @click="logout">Déconnexion</button>
    </div>
  </nav>
  <div class="overlay" v-if="menuOuvert" @click="menuOuvert = false"></div>
</template>

<script>
export default {
  name: 'AdminNav',
  data() { return { menuOuvert: false } },
  watch: { $route() { this.menuOuvert = false } },
  methods: {
    logout() {
      localStorage.removeItem('admin_token')
      this.$router.push('/admin')
    }
  }
}
</script>

<style scoped>
.admin-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #1a202c;
  color: white;
  padding: 0 24px;
  height: 56px;
  position: sticky;
  top: 0;
  z-index: 100;
  gap: 16px;
}

.nav-brand { font-size: 15px; font-weight: 700; white-space: nowrap; }

.nav-links { display: flex; gap: 4px; }
.nav-links a {
  color: rgba(255,255,255,0.75);
  text-decoration: none;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
  white-space: nowrap;
}
.nav-links a:hover,
.nav-links a.router-link-active { background: rgba(255,255,255,0.12); color: white; }

.btn-logout {
  background: rgba(255,255,255,0.1);
  border: none; color: white;
  padding: 6px 14px; border-radius: 8px;
  font-size: 13px; cursor: pointer; white-space: nowrap;
}
.btn-logout:hover { background: rgba(255,255,255,0.2); }

/* Mobile hamburger — caché sur desktop */
.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 26px; height: 18px;
  background: none; border: none;
  cursor: pointer; padding: 0;
}
.hamburger span {
  display: block; height: 2px;
  background: white; border-radius: 2px;
  transition: all 0.3s;
}
.hamburger.open span:nth-child(1) { transform: translateY(8px) rotate(45deg); }
.hamburger.open span:nth-child(2) { opacity: 0; }
.hamburger.open span:nth-child(3) { transform: translateY(-8px) rotate(-45deg); }

/* Mobile menu — caché par défaut */
.mobile-menu {
  display: none;
  position: fixed;
  top: 56px; left: 0; right: 0;
  background: #1a202c;
  flex-direction: column;
  padding: 8px 0;
  z-index: 99;
  box-shadow: 0 8px 24px rgba(0,0,0,0.3);
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
}
.mobile-menu.open {
  display: flex;
  opacity: 1;
  pointer-events: all;
}
.mobile-menu a {
  color: rgba(255,255,255,0.9);
  text-decoration: none;
  padding: 14px 20px;
  font-size: 15px;
  font-weight: 500;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}
.mobile-menu a:hover,
.mobile-menu a.router-link-active { background: rgba(255,255,255,0.1); color: white; }
.btn-logout-mobile {
  background: none; border: none;
  color: rgba(255,255,255,0.7);
  padding: 14px 20px; font-size: 15px;
  text-align: left; cursor: pointer; width: 100%;
}
.overlay { position: fixed; inset: 0; z-index: 98; background: rgba(0,0,0,0.4); }

/* Mobile : masquer liens et logout, afficher hamburger */
@media (max-width: 900px) {
  .nav-brand { font-size: 14px; }
  .nav-links { display: none; }
  .desktop-only { display: none; }
  .hamburger { display: flex; }
  .mobile-menu { top: 56px; }
}
</style>
